import type { StateCreator } from 'zustand';
import type { Preset } from '@/types';

import type { PresetSlice } from './types';

export type { PresetSlice } from './types';

export const presetInitialState = {
  selectedPreset: null as Preset | null,
  isPresetLoading: false,
};

export const createPresetSlice: StateCreator<
  PresetSlice,
  [],
  [],
  PresetSlice
> = (set) => ({
  ...presetInitialState,

  setSelectedPreset: (selectedPreset) => set({ selectedPreset }),
  setIsPresetLoading: (isPresetLoading) => set({ isPresetLoading }),
});
